import type { ZohoJobListingProps } from './types'

export default function ZohoJobListing({ site }: ZohoJobListingProps) {
	if (!site) {
		return null
	}

	// Empty container: Zoho's widget fills it in the browser. The `embed_jobs_*`
	// class names and the `rec_job_listing_div` id are Zoho's own hooks, so they
	// have to stay exactly as they are. `zoho-listing` is ours, for styling.
	return (
		<div className="embed_jobs_head embed_jobs_with_style_1 embed_jobs_with_style zoho-listing">
			<div className="embed_jobs_head2">
				<div className="embed_jobs_head3">
					<div
						id="rec_job_listing_div"
						data-zoho-job-listing
						data-zoho-site={site}
						data-zoho-widget-id="rec_job_listing_div"
					/>
				</div>
			</div>
		</div>
	)
}
